/**
 * Shared time-window formatters for the route-manager dashboard. All
 * window-related UI (today strip, window-filter dropdown, task bucket
 * headers) should pull from here so the day-of view reads consistently.
 *
 * Convention: 12-hour clock with AM/PM, suppress trailing `:00`, suppress
 * AM/PM on the start when both endpoints share it. Example outputs:
 *   ("09:00", "12:00") → "9 AM–12 PM"
 *   ("13:00", "17:00") → "1–5 PM"
 *   ("09:30", "12:00") → "9:30 AM–12 PM"
 */

export function formatWindowTime(hhmm: string): string {
  const [hStr, mStr] = hhmm.split(":");
  const h24 = parseInt(hStr, 10);
  const m = parseInt(mStr, 10);
  const period = h24 >= 12 ? "PM" : "AM";
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  const base = m === 0 ? `${h12}` : `${h12}:${mStr}`;
  return `${base} ${period}`;
}

export function formatWindowRange(startHhmm: string, endHhmm: string): string {
  const start = formatWindowTime(startHhmm);
  const end = formatWindowTime(endHhmm);
  const startPeriod = start.slice(-2);
  const endPeriod = end.slice(-2);
  if (startPeriod === endPeriod) {
    // Suppress the redundant AM/PM on the start when both sides share it
    return `${start.slice(0, -3)}–${end}`;
  }
  return `${start}–${end}`;
}

export function hhmmToMinutes(hhmm: string): number {
  const [h, m] = hhmm.split(":").map(Number);
  return h * 60 + m;
}
